import { createStore, applyMiddleware } from 'redux';
import ReduxThunk from 'redux-thunk';

import Reducers from '../reducers';
//import { loadState, saveState } from '../../utils';

//const persistedState = loadState();
const store = createStore(Reducers,
    //persistedState,
    applyMiddleware(ReduxThunk));

// store.subscribe(() => {
//     saveState({
//         faturamento: store.getState().faturamento
//     });
// });

export default store;